import React from "react";
import SolutionDetail from "../../components/SolutionDetail";
import "./Community/Paging.css";
import "./RequestList.css";

const RequestDetail = () => {
  return (
    <div style={{ marginTop: "300px" }}>
      <SolutionDetail type="create" />
    </div>
  );
};

export default RequestDetail;
